export const IMG = {
  hero: "https://images.unsplash.com/photo-1694521787162-5373b598945c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  construction: "https://images.unsplash.com/photo-1519143009590-e3800b9df468?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  renovation: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  electrical: "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  plumbing: "https://images.unsplash.com/photo-1646009445351-b8192e095f3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  painting: "https://images.unsplash.com/photo-1556775885-6a36fc57d012?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  villa: "https://images.unsplash.com/photo-1786010037911-445ae522f922?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interior: "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  frame: "https://images.pexels.com/photos/29152268/pexels-photo-29152268.jpeg?auto=compress&cs=tinysrgb&w=1400",
  kitchen: "https://images.unsplash.com/flagged/photo-1573168710465-7f7da9a23a15?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

const services = {
  el: [
    { key: "construction", title: "Κατασκευές", text: "Νέες κατοικίες, φέρων οργανισμός, τοιχοποιίες και επεκτάσεις — από τη θεμελίωση έως το κλειδί στο χέρι." },
    { key: "renovation", title: "Ανακαινίσεις", text: "Ολικές και μερικές ανακαινίσεις σπιτιών, κουζινών, μπάνιων και επαγγελματικών χώρων." },
    { key: "electrical", title: "Ηλεκτρολογικά", text: "Ηλεκτρικοί πίνακες, νέες εγκαταστάσεις, φωτισμός και αναβαθμίσεις δικτύων." },
    { key: "plumbing", title: "Υδραυλικά", text: "Δίκτυα ύδρευσης και αποχέτευσης, είδη υγιεινής, επισκευές διαρροών." },
    { key: "painting", title: "Βαφές", text: "Εσωτερικοί και εξωτερικοί χρωματισμοί, προετοιμασία επιφανειών και τελειώματα." },
  ],
  en: [
    { key: "construction", title: "Construction", text: "New homes, structural frames, masonry and extensions — from foundations to turnkey." },
    { key: "renovation", title: "Renovations", text: "Full and partial renovations of homes, kitchens, bathrooms and commercial spaces." },
    { key: "electrical", title: "Electrical", text: "Distribution panels, new installations, lighting and network upgrades." },
    { key: "plumbing", title: "Plumbing", text: "Water supply and drainage networks, sanitary fixtures, leak repairs." },
    { key: "painting", title: "Painting", text: "Interior and exterior painting, surface preparation and fine finishes." },
  ],
};

export const dict = {
  el: {
    nav: { services: "Υπηρεσίες", work: "Έργα", process: "Διαδικασία", contact: "Επικοινωνία", cta: "Ζητήστε προσφορά" },
    hero: {
      eyebrow: "Τεχνική εταιρεία · Μακεδονία, Ελλάδα",
      lines: ["Χτίζουμε", "με ακρίβεια.", "Ανακαινίζουμε"],
      accent: "με χαρακτήρα.",
      sub: "Κατασκευές, ανακαινίσεις, ηλεκτρολογικά, υδραυλικά και βαφές — ένα συνεργείο, ένας υπεύθυνος, ένα αποτέλεσμα.",
      cta: "Ζητήστε προσφορά",
      cta2: "Δείτε τις υπηρεσίες",
      badges: ["5 ειδικότητες", "Ένας υπεύθυνος", "Όλη η Μακεδονία"],
      scroll: "Κύλιση",
      card: "Φάκελος έργου",
      seo: "Ανακαινίσεις & Κατασκευές Κιλκίς",
    },
    marquee: ["Κατασκευές", "Ανακαινίσεις", "Ηλεκτρολογικά", "Υδραυλικά", "Βαφές", "Μακεδονία"],
    services: { eyebrow: "01 — Υπηρεσίες", title: "Ό,τι χρειάζεται ένα έργο,", accent: "κάτω από μία στέγη.", items: services.el, more: "Ζητήστε προσφορά" },
    work: {
      eyebrow: "02 — Τύποι έργων",
      title: "Από το σκελετό",
      accent: "μέχρι την τελευταία πινελιά.",
      items: [
        { img: "villa", title: "Νέα κατοικία", tag: "Κατασκευή" },
        { img: "interior", title: "Ολική ανακαίνιση", tag: "Ανακαίνιση" },
        { img: "frame", title: "Φέρων οργανισμός", tag: "Κατασκευή" },
        { img: "kitchen", title: "Κουζίνα & φωτισμός", tag: "Ηλεκτρολογικά" },
      ],
    },
    process: {
      eyebrow: "03 — Διαδικασία",
      title: "Τέσσερα βήματα.",
      accent: "Καμία έκπληξη.",
      steps: [
        { n: "01", title: "Αίτημα", text: "Μας περιγράφετε το έργο μέσω της φόρμας ή τηλεφωνικά." },
        { n: "02", title: "Αυτοψία", text: "Επισκεπτόμαστε τον χώρο, μετράμε και καταγράφουμε τις ανάγκες." },
        { n: "03", title: "Προσφορά", text: "Λαμβάνετε αναλυτική προσφορά με χρονοδιάγραμμα και κόστος." },
        { n: "04", title: "Υλοποίηση", text: "Εκτελούμε το έργο με συνέπεια και σας παραδίδουμε καθαρό χώρο." },
      ],
    },
    quote: {
      eyebrow: "04 — Αίτημα προσφοράς",
      title: "Πείτε μας",
      accent: "για το έργο σας.",
      sub: "Συμπληρώστε τη φόρμα και θα επικοινωνήσουμε μαζί σας το συντομότερο. Τα στοιχεία σας τα βλέπει μόνο η διοίκηση της εταιρείας.",
      name: "Ονοματεπώνυμο", phone: "Τηλέφωνο", email: "Email (προαιρετικό)", service: "Υπηρεσία", area: "Περιοχή / Πόλη", message: "Περιγραφή εργασίας",
      placeholderMsg: "π.χ. Ανακαίνιση μπάνιου 6 τ.μ. σε διαμέρισμα στη Θεσσαλονίκη",
      consent: "Συμφωνώ να χρησιμοποιηθούν τα στοιχεία μου μόνο για την επικοινωνία σχετικά με το αίτημά μου.",
      submit: "Αποστολή αιτήματος", sending: "Αποστολή...",
      success: "Το αίτημά σας εστάλη! Θα επικοινωνήσουμε σύντομα.", error: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
      required: "Συμπληρώστε τα υποχρεωτικά πεδία και αποδεχτείτε τους όρους.",
      other: "Άλλο",
      done: "Ευχαριστούμε!", doneSub: "Λάβαμε το αίτημά σας. Θα σας καλέσουμε σύντομα.", again: "Νέο αίτημα",
    },
    contact: { eyebrow: "05 — Επικοινωνία", title: "Είμαστε εδώ.", phone: "Τηλέφωνο", email: "Email", address: "Διεύθυνση", area: "Περιοχή εξυπηρέτησης", areaVal: "Μακεδονία, Ελλάδα" },
    footer: { rights: "Με επιφύλαξη παντός δικαιώματος.", admin: "Διαχείριση" },
  },
  en: {
    nav: { services: "Services", work: "Work", process: "Process", contact: "Contact", cta: "Get a quote" },
    hero: {
      eyebrow: "Technical works · Macedonia, Greece",
      lines: ["We build", "with precision.", "We renovate"],
      accent: "with character.",
      sub: "Construction, renovations, electrical, plumbing and painting — one crew, one point of contact, one result.",
      cta: "Get a quote",
      cta2: "See services",
      badges: ["5 trades", "One contact", "All of Macedonia"],
      scroll: "Scroll",
      card: "Project file",
      seo: "Renovations & Construction in Kilkis",
    },
    marquee: ["Construction", "Renovations", "Electrical", "Plumbing", "Painting", "Macedonia"],
    services: { eyebrow: "01 — Services", title: "Everything a project needs,", accent: "under one roof.", items: services.en, more: "Get a quote" },
    work: {
      eyebrow: "02 — Project types",
      title: "From the frame",
      accent: "to the final brushstroke.",
      items: [
        { img: "villa", title: "New residence", tag: "Construction" },
        { img: "interior", title: "Full renovation", tag: "Renovation" },
        { img: "frame", title: "Structural frame", tag: "Construction" },
        { img: "kitchen", title: "Kitchen & lighting", tag: "Electrical" },
      ],
    },
    process: {
      eyebrow: "03 — Process",
      title: "Four steps.",
      accent: "No surprises.",
      steps: [
        { n: "01", title: "Request", text: "Describe your project through the form or by phone." },
        { n: "02", title: "Site visit", text: "We visit, measure and record exactly what is needed." },
        { n: "03", title: "Quote", text: "You receive a detailed quote with timeline and cost." },
        { n: "04", title: "Delivery", text: "We execute consistently and hand over a clean space." },
      ],
    },
    quote: {
      eyebrow: "04 — Request a quote",
      title: "Tell us",
      accent: "about your project.",
      sub: "Fill in the form and we will get back to you shortly. Your details are seen only by company management.",
      name: "Full name", phone: "Phone", email: "Email (optional)", service: "Service", area: "Area / City", message: "Job description",
      placeholderMsg: "e.g. 6 m² bathroom renovation in a Thessaloniki apartment",
      consent: "I agree that my details are used only to contact me about this request.",
      submit: "Send request", sending: "Sending...",
      success: "Your request was sent! We will contact you soon.", error: "Something went wrong. Please try again.",
      required: "Fill in the required fields and accept the terms.",
      other: "Other",
      done: "Thank you!", doneSub: "We received your request and will call you soon.", again: "New request",
    },
    contact: { eyebrow: "05 — Contact", title: "We are here.", phone: "Phone", email: "Email", address: "Address", area: "Service area", areaVal: "Macedonia, Greece" },
    footer: { rights: "All rights reserved.", admin: "Admin" },
  },
};
